import React from 'react';
import { makeCSS } from '../../../utils/makeCSS';
import { Typography } from '../../atoms/Typography';
import { HBox } from '../layout/Flex';
import { Button } from '../../atoms/Button';
import { Card } from '../../atoms/Card';

const useCSS = makeCSS(({ theme }) => {
  return {
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: theme.color.background.neutral
    },
    header: {
      borderBottom: `1px solid ${theme.color.line['03']}`, // rgba(255, 255, 255, 0.04)
      width: '100%',
      height: 64,
      padding: '0 16px',
      boxSizing: 'border-box'
    },
    content: {
      position: 'relative',
      width: 'inherit',
      height: 'inherit'
    },
    boxesContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 16,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)'
    },
    box: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      width: theme.spacing['60'],
      height: theme.spacing['52'],
      justifyContent: 'center',
      alignItems: 'center',
      gap: 16,
      border: `dashed 1px ${theme.color.line['02']}`,
      textAlign: 'center',
      padding: 32,
      boxSizing: 'border-box',
      background: theme.color.overlay.dark['01'],
      borderRadius: theme.borderRadius['2xl'],
      '&:hover': {
        background: theme.color.overlay.dark['02']
      }
    }
  };
});

export const StartPage = (props) => {
  const { onClose, onStartFromScratch, onStartFromBaseImage } = props;

  const classes = useCSS();
  return (
    <section id={'generative_start'} className={classes.root}>
      <div className={classes.header}>
        <HBox align="center" style={{ paddingTop: 12 }}>
          <Typography>Generate with AI...</Typography>
          <Button iconLeft="close" onClick={onClose} />
        </HBox>
      </div>
      <div className={classes.content}>
        <div className={classes.boxesContainer}>
          <Typography colorVariant="03">
            {"Choose how you'd like to begin generating:"}
          </Typography>
          <HBox
            align="center"
            justify="center"
            gap={16}
            style={{ flexWrap: 'wrap' }}
          >
            <Card
              icon="sparkles"
              title="Start from scratch"
              content="Create a completely new image using only text prompts"
              onClick={onStartFromScratch}
            />
            <Card
              icon="image"
              title="Use base image"
              content="Select an image to use as a starting point"
              onClick={onStartFromBaseImage}
            />
          </HBox>
        </div>
      </div>
    </section>
  );
};
